import { useRecordContext } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { ShowSection } from '@sh4res/bo-common/components';
import { InstrumentScheduledEditsTable } from '@sh4res/bo-common/components/Instruments/sections/ScheduledEdits/components/InstrumentScheduledEditsTable';

export const InstrumentScheduledEditsSection = () => {
  const record = useRecordContext<GetInstrumentOneResponse>();

  if (!record) {
    return null;
  }

  return (
    <ShowSection label="resources.bo_common.instruments/scheduled_edits.title">
      <InstrumentScheduledEditsTable instrumentId={record.id} />
    </ShowSection>
  );
};
